import React from "react";
import {
  Box,
  Button,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import PlaceRoundedIcon from "@mui/icons-material/PlaceRounded";

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "14px",
    backgroundColor: "rgba(255,255,255,0.03)",
    "& fieldset": { borderColor: "rgba(255,255,255,0.12)" },
    "&:hover fieldset": { borderColor: "rgba(255,255,255,0.2)" },
    "&.Mui-focused fieldset": { borderColor: "rgba(0,225,255,0.55)" },
  },
  "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.58)" },
  "& .MuiInputBase-input": { color: "#fff" },
};

export default function DynamicList({
  items,
  value,
  onChange,
  onAdd,
  onRemove,
  placeholder,
}) {
  return (
    <Stack spacing={1.4}>
      <Stack direction={{ xs: "column", md: "row" }} spacing={1.2}>
        <TextField
          fullWidth
          label="Adicionar item"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              onAdd?.();
            }
          }}
          InputLabelProps={{ shrink: true }}
          sx={inputSx}
        />
        <Button
          variant="contained"
          startIcon={<AddRoundedIcon />}
          sx={{
            minHeight: 54,
            px: 2,
            borderRadius: 2,
            fontWeight: 900,
            textTransform: "none",
            background:
              "linear-gradient(135deg, rgba(0,225,255,0.95), rgba(109,255,178,0.95))",
            color: "#042014",
          }}
          onClick={onAdd}
        >
          Adicionar
        </Button>
      </Stack>

      {items.length > 0 ? (
        <Stack spacing={1}>
          {items.map((it, idx) => (
            <Stack
              key={`${it}-${idx}`}
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              spacing={1}
              sx={{
                p: 1.3,
                borderRadius: 2,
                border: "1px solid rgba(255,255,255,0.08)",
                bgcolor: "rgba(255,255,255,0.03)",
              }}
            >
              <Stack direction="row" spacing={1.1} alignItems="center" sx={{ minWidth: 0 }}>
                <Box
                  sx={{
                    width: 34,
                    height: 34,
                    display: "grid",
                    placeItems: "center",
                    borderRadius: 2,
                    bgcolor: "rgba(0,225,255,0.12)",
                    color: "#8ef4ff",
                    flexShrink: 0,
                  }}
                >
                  <PlaceRoundedIcon sx={{ fontSize: 18 }} />
                </Box>
                <Typography sx={{ fontWeight: 800, color: "rgba(255,255,255,0.92)" }}>
                  {it}
                </Typography>
              </Stack>

              <IconButton
                onClick={() => onRemove?.(idx)}
                sx={{
                  border: "1px solid rgba(255,255,255,0.1)",
                  color: "rgba(255,255,255,0.55)",
                }}
              >
                <CloseRoundedIcon fontSize="small" />
              </IconButton>
            </Stack>
          ))}
        </Stack>
      ) : (
        <Box
          sx={{
            borderRadius: 2,
            border: "1px dashed rgba(255,255,255,0.12)",
            p: 1.5,
            textAlign: "center",
          }}
        >
          <Typography sx={{ fontSize: 13, color: "rgba(255,255,255,0.46)" }}>
            Nenhum item adicionado ainda.
          </Typography>
        </Box>
      )}
    </Stack>
  );
}
